import { useContext } from 'react';
import { PopoverConfigContext } from './popover-config-provider';
export var usePopoverConfig = function usePopoverConfig() {
  var _useContext = useContext(PopoverConfigContext),
      config = _useContext.config;

  return config;
};
export default usePopoverConfig;